import React, {useEffect} from 'react';
import CardsContent from "./cards-content.jsx";
import WithoutValueContent from "./without-value-content.jsx";
import AgentIndexContent from "./agent-index-content.jsx";
import DispatchListContent from "./dispatch-list-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {translate} from "../../../../../components/translate/translate.jsx";

const ReportContent = ({ data, collapsed, dispatchList }) => {

    useEffect(() => {
        const cards = JSON.parse(data?.apply?.cards?.[0]?.value_data ?? '{}');

        if (Object.keys(cards).length > 0) {
            const values = [
                ["Total de despachos", cards?.total ?? 0],
                ["Incompletos", cards?.incomplete ?? 0],
                ["Completos (%)", cards?.complete ?? 0]
            ];

            ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, "Cards");
        }

        const withoutData = JSON.parse(data?.apply?.graphs?.[0]?.value_data ?? '{}');

        if (Object.keys(withoutData).length > 0) {
            const values = [];
            const labels = [];

            Object.entries(withoutData).forEach(([label, value]) => {
                if (label !== 'ignore') {
                    labels.push(translate(label));
                    values.push(value);
                }
            });

            ReportUtils.createExportableTable(labels, values, 'Campos sem preenchimento', null, ["Campos", "Quantidade"]);
        }

        if ((data?.apply?.user_fill ?? []).length > 0) {
            const tableData = data.apply.user_fill.map(item => JSON.parse(item.value_data));

            const labels = ["Agente", "Natureza", "Obs. inicial", "Obs. final", "Local pré-cadastrado", "Logradouro", "Número", "Bairro", "Setor", "Latitude/Longitude"];
            const values = [];

            tableData.forEach((element) => {
                const table_values = element?.table_values ?? {};

                values.push([
                    element.user_name,
                    table_values.nature,
                    table_values.obs,
                    table_values.obs_final,
                    table_values.place,
                    table_values.street,
                    table_values.number,
                    table_values.neighborhood,
                    table_values.sector,
                    table_values.lat
                ]);
            });

            ReportUtils.createExportableTable(labels, values, 'Índices de preenchimento');
        }

        if (dispatchList && data?.dispatch_list?.length > 0) {
            const labels = ["Talão", "Agente", "D/H do despacho", "Campos não preenchidos"];
            const values = [];

            data?.dispatch_list.map((element) => {
                values.push([
                    element.numbercheckbook ?? "Sem talão",
                    element.user_name ?? "",
                    element.dispatch_start ?? "",
                    element.without_info ?? ""
                ]);
            })

            ReportUtils.createExportableTable(labels, values, 'Lista de despachos');
        }

    }, [data]);


    return (
        <>

            <CardsContent key={`cards-${collapsed}`} data={data?.apply}/>

            <WithoutValueContent key={`without-${collapsed}`} data={data?.apply}/>

            <AgentIndexContent key={`index-${collapsed}`} data={data?.apply}/>

            { dispatchList && data?.dispatch_list?.length > 0 && (
                <>
                    <div className={`chart-divisor ${data?.dispatch_list?.length >= 13 ? "mb-6!" : ""}`}/>
                    <DispatchListContent key={`dispatch-${collapsed}`} data={data?.dispatch_list}/>
                </>
            )}

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;